import * as Yup from 'yup'

const registerFormSchema = Yup.object({
  email: Yup.string()
    .email('Debes introducir un correo electrónico')
    .required('Debes introducir un correo electrónico'),
  password: Yup.string().required('Debes introducir la contraseña'),
  passwordConfirmation: Yup.string()
    .required('Debes confirmar la contraseña')
    .when('password', {
      is: (val: any) => (val && val.length > 0 ? true : false),
      then: Yup.string().oneOf([Yup.ref('password')], 'Las contraseñas tienen que coincidir'),
    }),
  gdpr: Yup.bool().oneOf([true]),
})

export default registerFormSchema
